import { c as _c } from "react/compiler-runtime";
import { automationRuleDependencies } from 'modules/automation-rules/constants/automation-rule-dependencies';
import { AutomationRuleApiInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { FUNNEL_STEP_API } from 'modules/funnels/funnel/api/funnel-api';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const useFunnelStepRules = funnelStepId => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== funnelStepId || $[2] !== user) {
    t1 = () => {
      if (!user || !funnelStepId) {
        return;
      }
      return [`${FUNNEL_STEP_API}/${funnelStepId}/automation-rules`, ...automationRuleDependencies];
    };
    $[1] = funnelStepId;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useControlledSwr(t1, fetcher);
};